import React, { useMemo } from 'react'
import { Box, MenuItem } from '@mui/material'
import LiquidSelect from '@src/components/LiquidSelect'
import { useSearchQuery } from '../../../pages/[country]/[language]/search/[searchTerm]'
import { Sort } from '@src/types/graphql-types'
import { useIntl } from 'react-intl'
import { searchSortOptions } from '../config'

const SearchResultsSortBar = () => {
  const [query, , queryActions] = useSearchQuery()
  const { formatMessage } = useIntl()

  const sortOptions = useMemo(
    () =>
      searchSortOptions[query.focus].map((option) => ({
        ...option,
        label: formatMessage(option.label),
      })),
    [formatMessage, query.focus]
  )

  return (
    <Box>
      <LiquidSelect
        style={{ minWidth: 204 }}
        fullWidth={false}
        size="small"
        value={query.sort}
        onChange={(e) => {
          queryActions.handleSortChange(e.target.value as Sort)
        }}
        id="srp-sort-options"
      >
        {sortOptions.map(({ value, label }) => (
          <MenuItem key={value} value={value} id={`sort-option-${value}`}>
            {label}
          </MenuItem>
        ))}
      </LiquidSelect>
    </Box>
  )
}

export default SearchResultsSortBar
